import { getOwnerId } from 'legacy/lut/selectors/app'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'
import { compose } from 'redux'

import { REQUEST_LANDING_DATA } from 'partner360/features/landing/constants'
import { IFetchLandingResult } from 'partner360/models/landing/IFetchLandingResult'
import { fetchLandingData } from 'partner360/services/landing/fetchLandingData'

interface IRequestLandingData {
  isRefreshing?: boolean
}

export const requestLandingData = createAsyncThunk<
  IFetchLandingResult | null,
  IRequestLandingData | void
>(REQUEST_LANDING_DATA, async (_, { getState }) => {
  const ownerId = compose(getOwnerId, getState)()

  return await fetchLandingData({
    ownerId,
  })
})
